import { useState } from 'react';
import { heroPreviews, heroStats } from '@/mocks/home';

const QUICK_TAGS = ['今日热榜', '评论最多', '细节研究所', '观点对撞'];

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const [message, setMessage] = useState('');

  const runSearch = () => {
    if (!keyword.trim()) {
      setMessage('先输入一个词，比如「时间线」「彩蛋」「联名」，再开始找话题');
      return;
    }
    setMessage(`正在为你筛出与「${keyword.trim()}」相关的讨论角度（演示效果）`);
  };

  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="absolute inset-x-0 top-0 h-40 bg-background-100" />
      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-12 pt-10 md:px-6 md:pb-16 md:pt-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-fire-fill text-accent-500" />
              </span>
              社区互动 · 吃瓜现场实时更新
            </span>

            <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-[42px] md:leading-[1.15]">
              黑料社网社区
              <span className="mx-2 text-primary-500">/</span>
              把热门话题聊到细节里
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
              进入黑料社网社区，与吃瓜群众一起参与热门话题讨论。看爆料、读评论、发观点，在互动中挖掘更多隐藏细节，体验不一样的吃瓜氛围。
            </p>

            <div className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
              <div className="flex h-11 flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
                <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                  <i className="ri-search-2-line text-sm" />
                </span>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') runSearch();
                  }}
                  placeholder="想围观哪个话题？输入关键词开始找"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                />
              </div>
              <button
                type="button"
                onClick={runSearch}
                className="h-11 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始找话题
              </button>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500">大家在聊：</span>
              {QUICK_TAGS.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => {
                    setKeyword(tag);
                    setMessage(`已填入「${tag}」，点击开始找话题查看相关讨论（演示效果）`);
                  }}
                  className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {tag}
                </button>
              ))}
            </div>

            {message && (
              <p className="mt-4 flex items-center gap-2 text-xs text-secondary-800">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-checkbox-circle-line text-sm" />
                </span>
                {message}
              </p>
            )}

            <div className="mt-9 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-3">
              {heroStats.map((stat) => (
                <div key={stat.id} className="bg-background-50 px-4 py-4">
                  <div className="flex items-baseline gap-1">
                    <strong className="font-heading text-2xl font-bold text-foreground-950">{stat.value}</strong>
                    <span className="text-xs text-foreground-500">{stat.suffix}</span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-4">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-700">正在被围观的话题</span>
                <span className="flex items-center gap-1 text-xs text-accent-600">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-live-line text-sm" />
                  </span>
                  实时
                </span>
              </div>
              <div className="flex flex-col gap-3">
                {heroPreviews.map((item) => (
                  <a
                    key={item.id}
                    href="#topics"
                    className="flex cursor-pointer items-center gap-3 rounded-md border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300"
                  >
                    <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                      <img src={item.image} alt={item.title} className="h-full w-full object-cover object-top" />
                    </div>
                    <div className="min-w-0">
                      <span className="inline-block rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                        {item.tag}
                      </span>
                      <p className="mt-1 truncate text-sm font-medium text-foreground-900">{item.title}</p>
                      <p className="mt-0.5 flex items-center gap-1 text-xs text-foreground-500">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-chat-3-line text-xs" />
                        </span>
                        {item.comments} 条评论
                      </p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}